<template>
  <div class="block">
      <el-timeline>
        <hr>
        <el-timeline-item
          v-for="(item) in workList" :key="item.id"
          placement="top" style="width: 810px">
          <el-card>
            <h7>大赛名称: {{item.siteName}}</h7>
            <hr>
            <p>作品类型: {{item.name}}</p>
            <p>作品名称: {{JSON.parse(item.data).workName}}</p>
            <p>成绩: {{item.label}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    <p style="text-align: center" v-if="record">暂无数据</p>
    </div>
</template>
<script>
  import {getWorkLists, getUserInfo} from '../../../api/work/workfield'

  export default {
    components: {},
    name: "workLists",
    data() {
      return {
        workList: [],
        record: false
      }
    },
    methods: {
    },
    created() {
      getUserInfo(this.authURL).then(res => {
        let userId = res.user.userId;
        getWorkLists(this.siteURL, userId).then(res => {
          if (res.data == null || res.data == ''){
            this.record = true
          }
          this.workList = res.data
        })
      })
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/my/components/raceCourse.vue